<div class="title-container">
  <div class="title">{{ getTitle() | translate }}</div>
  <div>
    <ai-knowledge-last-scraped
      [knowledgeSource]="knowledgeSource"
      [allowRescrapeWebsite]="true"
      [hasUnsavedChanges]="hasUnsavedChanges()"
      (rescrapeInitiated)="rescrapeInitiated()"
    >
    </ai-knowledge-last-scraped>
  </div>
</div>

<mat-dialog-content class="content">
  @if (isLoading()) {
    <glxy-loading-spinner></glxy-loading-spinner>
  }
  <div [ngClass]="{ hidden: isLoading() }">
    @if (knowledgeSource?.isSuggested) {
      <div class="read-only-info">
        <div>
          <a [href]="websiteScrapeConfig?.url" target="_blank">
            {{ websiteScrapeConfig?.url }}
            <mat-icon inline="true" class="open-in-new" iconPositionEnd>open_in_new</mat-icon>
          </a>
        </div>
        <div>
          {{ getCrawlModeTranslationKey(websiteScrapeConfig?.crawlMode) | translate }}
        </div>
      </div>
      <ng-container *ngTemplateOutlet="scrapedPagesSummary"></ng-container>
    } @else {
      <mat-stepper #stepper [labelPosition]="'bottom'" (selectionChange)="stepChanged($event)">
        <mat-step>
          <ng-template matStepLabel>{{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.FIND_PAGES' | translate }}</ng-template>
          <ng-template matStepContent>
            @if (
              (websiteScrapeConfig &&
                websiteScrapeConfig.scrapeProgress !== scrapeProgressStates.WEBSITE_SCRAPE_CONFIG_PROGRESS_DONE) ||
              delayProgressScreenClosure
            ) {
              <glxy-empty-state class="scrape-in-progress">
                <glxy-empty-state-hero>
                  <ai-knowledge-loading-spinner />
                </glxy-empty-state-hero>
                <glxy-empty-state-title>
                  {{ getScrapeProgressTitle() | translate }}
                  @if (
                    (websiteScrapeConfig.scrapeProgress ===
                      scrapeProgressStates.WEBSITE_SCRAPE_CONFIG_PROGRESS_IN_PROGRESS &&
                      scrapeProgressPagesFound > 0) ||
                    (delayProgressScreenClosure &&
                      websiteScrapeConfig.scrapeProgress === scrapeProgressStates.WEBSITE_SCRAPE_CONFIG_PROGRESS_DONE)
                  ) {
                    {{ scrapeProgressPagesFound }}
                  }
                </glxy-empty-state-title>
                <p>{{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.SCRAPE_IN_PROGRESS_CLARIFICATION_DEFAULT' | translate }}</p>
              </glxy-empty-state>
            } @else {
              @if (shouldShowError()) {
                <glxy-empty-state [size]="'small'">
                  <glxy-empty-state-hero>
                    <mat-icon>warning</mat-icon>
                  </glxy-empty-state-hero>
                  <glxy-empty-state-title>
                    {{
                      'WEBSITE_SCRAPE.ERRORS.TITLE'
                        | translate: { url: knowledgeSource?.config?.websiteScrapeConfig?.url }
                    }}
                  </glxy-empty-state-title>
                  <p>
                    {{
                      knowledgeSource.config.websiteScrapeConfig.error?.errorMessage
                        | translate: { url: knowledgeSource?.config?.websiteScrapeConfig?.url }
                    }}
                  </p>
                  <glxy-empty-state-actions>
                    <button mat-stroked-button (click)="rescrape()">
                      {{ 'WEBSITE_SCRAPE.ERRORS.ACTIONS.TRY_AGAIN' | translate }}
                    </button>
                    <button mat-flat-button color="primary" (click)="editError()">
                      {{ 'WEBSITE_SCRAPE.ERRORS.ACTIONS.GO_BACK' | translate }}
                    </button>
                  </glxy-empty-state-actions>
                </glxy-empty-state>
              } @else {
                <ng-container [formGroup]="form">
                  <glxy-form-field [required]="true">
                    <glxy-label>{{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.URL' | translate }}</glxy-label>
                    <input matInput type="text" formControlName="url" [required]="true" />
                    @if (form.get('url')?.errors && form.get('url')?.dirty) {
                      <glxy-error>
                        {{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.INVALID_URL' | translate }}
                      </glxy-error>
                    }
                    <glxy-hint>
                      {{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.URL_HINT' | translate }}
                    </glxy-hint>
                  </glxy-form-field>
                  <glxy-form-field>
                    <glxy-label>{{ 'EDIT_KNOWLEDGE.NAME' | translate }}</glxy-label>
                    <input
                      matInput
                      formControlName="name"
                      [placeholder]="'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.MY_WEBSITE' | translate"
                    />
                  </glxy-form-field>
                  <glxy-form-field [required]="true">
                    <glxy-label>{{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.CRAWL_MODE' | translate }}</glxy-label>
                    <mat-select (selectionChange)="crawlModeChange($event)" formControlName="crawlMode">
                      @for (crawlModeOption of getCrawlModeOptions(); track crawlModeOption) {
                        <mat-option [value]="crawlModeOption">
                          {{ getCrawlModeTranslationKey(crawlModeOption) | translate }}
                        </mat-option>
                      }
                    </mat-select>
                    @if (form.get('crawlMode')?.value === crawlModes.WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_RECURSIVE) {
                      <glxy-hint>
                        {{
                          'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.FOLLOW_LINKS_HINT'
                            | translate: { pageLimit: getPageLimit() }
                        }}
                      </glxy-hint>
                    } @else if (form.get('crawlMode')?.value === crawlModes.WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_SITEMAP) {
                      <glxy-hint>
                        {{
                          'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.SITEMAP_HINT' | translate: { pageLimit: getPageLimit() }
                        }}
                      </glxy-hint>
                    }
                  </glxy-form-field>
                  @if (
                    form.get('crawlMode')?.value === crawlModes.WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_RECURSIVE ||
                    form.get('crawlMode')?.value === crawlModes.WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_SITEMAP
                  ) {
                    <glxy-form-field>
                      <glxy-label>{{ 'WEBSITE_SCRAPE.EXCLUDED_PATHS.TITLE' | translate }}</glxy-label>
                      <mat-chip-grid #pathChips>
                        @for (path of excludedPaths; track path) {
                          <mat-chip-row [removable]="true" (removed)="removeExcludedPath(path)">
                            {{ path }}
                            <button matChipRemove [attr.aria-label]="'remove ' + path">
                              <mat-icon>cancel</mat-icon>
                            </button>
                          </mat-chip-row>
                        }
                        <input
                          placeholder="/path"
                          [matChipInputFor]="pathChips"
                          [matChipInputAddOnBlur]="true"
                          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          (matChipInputTokenEnd)="addExcludedPath($event)"
                        />
                      </mat-chip-grid>
                      @if (excludedPathError()) {
                        <glxy-error>{{ excludedPathError() | translate }}</glxy-error>
                      }
                      <glxy-hint>{{ 'WEBSITE_SCRAPE.EXCLUDED_PATHS.DESCRIPTION' | translate }}</glxy-hint>
                    </glxy-form-field>
                  }
                  <glxy-form-field bottomSpacing="none">
                    <mat-checkbox formControlName="automaticRefresh"
                      >{{ 'WEBSITE_SCRAPE.ENABLE_AUTOMATIC_RESCRAPE' | translate }}
                    </mat-checkbox>
                  </glxy-form-field>
                </ng-container>
                <ng-container *ngTemplateOutlet="scrapedPagesSummary"></ng-container>
              }
            }
          </ng-template>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>{{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.TRAIN' | translate }}</ng-template>
          <ng-template matStepContent>
            <ai-knowledge-scraped-pages
              #scrapedPagesComponent
              [knowledgeSource]="this.knowledgeSource"
              [shouldShowDone]="shouldShowDone()"
            ></ai-knowledge-scraped-pages>
          </ng-template>
        </mat-step>
        @if (!excludeAddToAIStep) {
          <mat-step>
            <ng-template matStepLabel>{{ 'EDIT_KNOWLEDGE.ADD_TO_AI' | translate }}</ng-template>
            <ng-template matStepContent>
              <ai-knowledge-application-selector
                #applicationSelector
                [knowledgeSourceId]="knowledgeSource?.id"
                (createWidgetClicked)="createWebChatWidget()"
              ></ai-knowledge-application-selector>
            </ng-template>
          </mat-step>
        }
      </mat-stepper>
    }

    <ng-template #scrapedPagesSummary>
      @if (knowledgeSource) {
        <div class="scraped-pages">
          @if (knowledgeSource.isSuggested) {
            <div>
              {{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.SCRAPE_WILL_BE_QUEUED' | translate }}
            </div>
          } @else if (
            websiteScrapeConfig?.scrapeProgress !== scrapeProgressStates.WEBSITE_SCRAPE_CONFIG_PROGRESS_DONE
          ) {
            <div>
              <glxy-loading-spinner [inline]="true"></glxy-loading-spinner>
              {{ getScrapeProgressTitle() | translate }}
            </div>
          }
        </div>
      }
    </ng-template>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="actions">
    @if (otherAIDisclaimer()) {
      <div class="used-with-other-ai">{{ otherAIDisclaimer() }}</div>
    }
    <div class="buttons">
      @if (showBack() && !shouldShowDone()) {
        <div class="card-actions__secondary">
          <button mat-stroked-button (click)="back()">{{ 'COMMON.BACK' | translate }}</button>
        </div>
      }

      <div class="card-actions__primary">
        <button mat-stroked-button (click)="close()">{{ 'COMMON.CLOSE' | translate }}</button>
        @if (!knowledgeSource?.isSuggested && !shouldShowDone()) {
          <button mat-flat-button color="primary" (click)="submit()" [disabled]="disableSubmit">
            {{ getSubmitAction() | translate }}
          </button>
        }
      </div>
    </div>
  </div>
</mat-dialog-actions>
